module.exports = __webpack_public_path__ + "static/GodastrologyA-d987cffc16deb6f8a2991f1bc562d6e8.gif";